<template>
  <div class="message-main">
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="7" :lg="6" :md="8" :sm="24">
              <a-form-item label="任务标题">
                <a-input
                  placeholder="请输入任务标题"
                  v-model="queryParam.title"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="7" :lg="6" :md="8" :sm="24">
              <a-form-item label="手机号">
                <a-input
                  placeholder="请输入手机号"
                  v-model="queryParam.account"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="10" :lg="12" :md="18" :sm="24">
              <a-form-item label="发送时间">
                <a-range-picker
                  :placeholder="['开始时间', '结束时间']"
                  :value="createValue"
                  @change="handleChange"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [
                      moment('00:00:00', 'HH:mm:ss'),
                      moment('11:59:59', 'HH:mm:ss'),
                    ],
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="7" :lg="6" :md="8" :sm="24">
                <a-form-item label="客户名称">
                  <a-input
                    placeholder="请输入客户名称"
                    v-model="queryParam.userName"
                  ></a-input>
                </a-form-item>
              </a-col>

              <a-col :xl="7" :lg="6" :md="8" :sm="24">
                <a-form-item label="短信状态">
                  <a-select
                    showSearch
                    v-model="queryParam.sendStatus"
                    placeholder="请选择状态"
                  >
                    <a-select-option
                      v-for="(item, index) in sendList"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :xl="7" :lg="6" :md="8" :sm="24">
                <a-form-item label="短信内容">
                  <a-input
                    placeholder="请输入短信内容"
                    v-model="queryParam.content"
                  ></a-input>
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="7" :lg="6" :md="8" :sm="24">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? '收起' : '展开' }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"
              ><a-icon type="delete" />批量重发</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作 <a-icon type="down"
          /></a-button>
        </a-dropdown>
      </div>

      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>

        <a-table
          ref="table"
          size="middle"
          :scroll="{ x: true }"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          class="j-table-force-nowrap"
          @change="handleTableChange"
        >
          <span slot="mgTkInfos" slot-scope="text">
            {{ text ? text[0].title : '--' }}
          </span>
          <span slot="paramFormats" slot-scope="text">
            {{ text ? text[0].userName : '--' }}
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="handleAudit(record.id)" v-if="record.sendStatus == 0"
              >重发</a
            >
            <a-divider type="vertical" v-if="record.sendStatus == 0" />
            <a @click="handleLook(record)">查看</a>
          </span>
        </a-table>
      </div>
      <message-center-modal ref="lookModal"></message-center-modal>
    </a-card>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less';
import JDate from '@/components/jeecg/JDate';
import MessageCenterModal from './modules/messageCenterModal.vue';
// import customRender from '@/utils/customRender.js';
import { postTag } from '@/api/manage';
import { filterObj } from '@/utils/util';
import moment from 'moment';

export default {
  name: 'MessageCenterList',
  components: {
    JDate,
    MessageCenterModal,
  },
  data() {
    return {
      loading: false,
      selectedRowKeys: [],
      toggleSearchStatus: false,
      selectionRows: [],
      dataSource: [], //table数据
      createValue: [],
      sendList: [
        {
          name: '发送失败',
          value: 0,
        },
        {
          name: '发送成功',
          value: 1,
        },
        {
          name: '重发成功',
          value: 2,
        },
      ],
      queryParam: {
        //查询数据
        title: '',
        userName: '',
        account: '',
        content: '',
        createStartTime: '',
        createEndTime: '',
        sendStatus: '',
      },
      endTime: [],
      startTime: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      // 表头
      columns: [
        {
          title: '任务标题',
          align: 'center',
          dataIndex: 'mgTkInfos',
          scopedSlots: { customRender: 'mgTkInfos' },
        },
        {
          title: '发送时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'account',
        },
        {
          title: '客户名称',
          align: 'center',
          dataIndex: 'paramFormats',
          scopedSlots: { customRender: 'paramFormats' },
        },
        {
          title: '短信状态',
          align: 'center',
          dataIndex: 'sendStatus',
          customRender: (text) => {
            if (text == 0) {
              return '发送失败';
            } else if (text == 1) {
              return '发送成功';
            } else if (text == 2) {
              return '重发成功';
            }
          },
        },
        {
          title: '短信内容',
          align: 'center',
          dataIndex: 'content',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkDetail/page',
        send: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkDetail/reSend',
        sendBatch: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkDetail/batchReSend',
      },
      dictOptions: {},
      superFieldList: [],
    };
  },
  created() {
    if (this.$route.query.title) {
      this.queryParam.title = this.$route.query.title;
    }
    if (this.$route.query.status) {
      this.queryParam.sendStatus = parseInt(this.$route.query.status);
    }
    this.getList();
  },
  methods: {
    moment,
    // 查看
    handleAudit(id) {
      let that = this;
      that.$confirm({
        title: '提示',
        content: '确定重发该任务！',
        onOk: function () {
          that.checkVisible = false;
          postTag(that.url.send, { id: id }).then((res) => {
            that.loading = false;
            if (res.success) {
              that.getList(1);
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },
    //批量重发
    batchDel() {
      if (!this.url.sendBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      let isHasReview = this.selectionRows.some((item) => {
        return item.checkStatus == 1;
      });
      if (isHasReview) {
        this.$message.warning('已重发的的数据不能重发');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = [];
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids.push(this.selectedRowKeys[a]);
        }
        var that = this;
        this.$confirm({
          title: '确认重发',
          content: '是否重发选中数据?',
          onOk: function () {
            that.loading = true;
            postTag(that.url.sendBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList(1);
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    //获取查询条件
    getQueryParams() {
      let param = Object.assign(this.queryParam, this.isorter);
      param.id = this.$route.query.id;
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function (value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    // 查看
    handleLook(record) {
      this.$refs.lookModal.add(record);
    },
    initDictConfig() {},
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(this.selectionRows, '>>>>');
    },
    // 获取数据
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      postTag(that.url.list, params)
        .then((res) => {
          that.loading = true;
          if (res.success) {
            that.dataSource = res.result.records;
            console.log(that.dataSource);
            that.ipagination.total = res.result.total;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    //获取查询条件
    getQueryParams() {
      let param = Object.assign(this.queryParam, this.isorter);
      if (this.$route.query.id) {
        param.msgTaskId = this.$route.query.id;
      }
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function (value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //查询
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      this.createValue = [];
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    //获取创建时间
    handleChange(date, dateStrings) {
      this.createValue = date;
      let startTime = dateStrings[0];
      let endTime = dateStrings[1];
      if (startTime == '' || endTime == '') {
        this.queryParam.createStartTime = '';
        this.queryParam.createEndTime = '';
      } else {
        this.queryParam.createStartTime = startTime;
        this.queryParam.createEndTime = endTime;
      }
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
.delBtn {
  border: none;
  background-color: #ffffff;
}
.message-main {
  height: 100%;
}
</style>
